import { Box, Typography } from '@mui/material';
import React from 'react';

const Title = ({ title }) => {
  return (
    <Box display="flex" alignItems="center">
      <Typography variant="h6" fontWeight={700}>
        {title}
      </Typography>
    </Box>
  );
};

export default Title;
